import { render, staticRenderFns } from "./VehicleDetails.vue?vue&type=template&id=4304eb9a&scoped=true"
import script from "./VehicleDetails.vue?vue&type=script&lang=js"
export * from "./VehicleDetails.vue?vue&type=script&lang=js"
import style0 from "./VehicleDetails.vue?vue&type=style&index=0&id=4304eb9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4304eb9a",
  null
  
)

export default component.exports